import { useLanguage } from "@/i18n/LanguageContext";
import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "tr", label: "Türkçe", flag: "TR" },
  { code: "en", label: "English", flag: "EN" },
  { code: "ar", label: "العربية", flag: "AR" },
];

const LanguageSwitcher = ({ variant = "default" }) => {
  const { lang, setLang } = useLanguage();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  const triggerClass =
    variant === "light"
      ? "text-white/90 hover:text-white"
      : "text-[#2D2824] hover:text-[#B5441E]";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher-trigger"
        className={`inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] font-medium transition-colors ${triggerClass}`}
      >
        <span>{current.flag}</span>
        <ChevronDown size={14} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onSelect={() => setLang(l.code)}
            className={lang === l.code ? "bg-[#F4EFE6]" : ""}
          >
            <span className="font-medium me-2">{l.flag}</span>
            <span className="text-[#5C4D3C]">{l.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
